/* eslint-disable*/
// @ts-nocheck TOOD
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import axios, { AxiosResponse } from 'axios'
import {
  educationLevelOptions,
  emergencyContactOptions,
  employeesInitialState,
  logisticsTransportationTypes,
  transportationVehicleTypes,
} from 'pages/Employees/employeesData'
import { dietaryPreferences } from 'pages/Food/foodData'
import { toast } from 'react-toastify'
import { RootState } from 'store'
import { IPaginatedResponse } from 'types/api/general.interface'
import {
  IAllEmployeesSingleResponse,
  IDocumentDataCreateResponse,
  IEmployeeContractInResponse,
  IEmployeeDocumentResponse,
  IEmployeesStatsResponse,
  IGetAllEmployeesSimpleInfoSingleResponse,
  ISingleEmployeeGetResponse,
  ISingleEmployeePatchRequest,
  ISingleEmployeePostRequest,
  ITerminateContractPostRequest,
} from 'types/api/usersApi.interface'
import { IOperationGroup } from 'types/operations.interface'
import { IContract, IEmployee, IEmployeeSlice, IContra } from 'types/users.interface'
import { baseUrl } from 'utils/axios'
import { dataURItoBlob, handleErrors, formatParams, getParams } from 'utils/helpers'

const initialState: IEmployeeSlice = {
  isLoading: false,
  users: [],
  singleUser: null,
  totalCount: null,
  totalPages: null,
  stats: null,
  infoShifts: [],
}

export const importUsers = createAsyncThunk('users/importUsers', async (file: File, thunkAPI) => {
  const formData = new FormData()
  formData.append('file', file)
  try {
    const resp: AxiosResponse = await baseUrl.post('users/import', formData)
    return resp.data
  } catch (error) {
    console.log(error)
    return thunkAPI.rejectWithValue(error)
  }
})

export const getUsers = createAsyncThunk('users/getUsers', async (params: any, thunkAPI) => {
  try {
    params = formatParams(params)
    const resp: AxiosResponse<IPaginatedResponse<IAllEmployeesSingleResponse>> = await baseUrl.get(
      'users',
      { params },
    )
    return resp.data
  } catch (error) {
    return thunkAPI.rejectWithValue(error)
  }
})

export const getUsersSimpleInfo = createAsyncThunk(
  'users/getUsersSimpleInfo',
  async (params: any, thunkAPI) => {
    try {
      params = formatParams(params)
      const resp: AxiosResponse<
        IPaginatedResponse<IPaginatedResponse<IGetAllEmployeesSimpleInfoSingleResponse>>
      > = await baseUrl.get('users/basic', { params })
      return resp.data
    } catch (error) {
      return thunkAPI.rejectWithValue(error)
    }
  },
)

export const deleteUser = createAsyncThunk('users/deleteUsers', async (id: any, thunkAPI) => {
  try {
    await baseUrl.delete('users/' + id)
    await thunkAPI.dispatch(getUsersSimpleInfo(getParams({ location })))
    return id
  } catch (error) {
    console.log(error)
    return thunkAPI.rejectWithValue(error)
  }
})

export const terminateContract = createAsyncThunk(
  'users/terminateContract',
  async (
    {
      id,
      data,
      fromUserPage,
    }: { id: any; data: ITerminateContractPostRequest; fromUserPage?: boolean },
    thunkAPI,
  ) => {
    try {
      await baseUrl.post(`users/${id}/contract/terminate`, data)
      if (!fromUserPage) {
        await thunkAPI.dispatch(getUsersSimpleInfo(getParams({ location })))
      } else {
        await thunkAPI.dispatch(getSingleUser(id))
      }
      return fromUserPage || null
    } catch (error) {
      console.log(error)
      return thunkAPI.rejectWithValue(error)
    }
  },
)

export const getSingleUser = createAsyncThunk(
  'users/getSingleUser',
  async (id: string, thunkAPI) => {
    try {
      const resp: AxiosResponse<ISingleEmployeeGetResponse> = await baseUrl.get('users/' + id)
      console.log(resp.data)
      delete resp.data.sub
      resp.data.documents = resp.data.documents?.map((d: IEmployeeDocumentResponse) => ({
        id: d.id,
        category: d.category,
        accessRestrictions: d.accessRestrictions,
        effectiveDate: new Date(d.effectiveDate),
        expiryDate: new Date(d.expiryDate),
        capability: d.capability
          ? {
              value: d.capability.id,
              label: d.capability.name,
              requiresExpiry: false,
            }
          : null,
        url: d.currentUserDocumentFile.fileUrl,
        fileName: d.currentUserDocumentFile.fileName,
        uploadedAt: new Date(d.uploadedAt),
        alreadyCreated: true,
      }))
      resp.data.department = resp.data?.department
        ? { value: resp.data?.department.id, label: resp.data.department.name }
        : null
      resp.data.foodDietaryPreferenceType = dietaryPreferences.find(
        (o) => o.value == resp.data.foodDietaryPreferenceType,
      )
      resp.data.educationLevelType = educationLevelOptions.find(
        //TODO Ujednaciti sa ostalim select poljima kako se fetchuju
        (o) => o.value == resp.data.educationLevelType,
      )

      if (resp.data.emergencyContact?.type) {
        resp.data.emergencyContact.type = emergencyContactOptions.find(
          (o) => o.value == resp.data.emergencyContact.type,
        )
      }

      resp.data.contracts = resp.data.contracts.map((item: IEmployeeContractInResponse) => {
        if (item.logisticsInfo) {
          item.role = { value: item.role?.id, label: item?.role?.name }
        }

        return {
          ...item,
          contractIndefinite: item.endDate ? false : true,
        }
      })

      resp.data.notes = resp.data.notes?.map((d) => ({ ...d, alreadyCreated: true })) || []
      console.log(resp.data)
      return resp.data
    } catch (error) {
      console.log(error)
      return thunkAPI.rejectWithValue(error)
    }
  },
)
export const addUser = createAsyncThunk('users/addUser', async (state: IEmployee, thunkAPI) => {
  try {
    const user = structuredClone(state)

    const { image } = user
    delete user.image
    const forSubmit: ISingleEmployeePostRequest = {
      firstName: user.firstName,
      lastName: user.lastName,
      nationality: user.nationality,
      nationalId: user.nationalId,
      departmentId: user.department?.value,
      foodDietaryPreferenceType: user.foodDietaryPreferenceType?.value,
      shouldSendTemporaryPassword: user.shouldSendTemporaryPassword,
      accessType: user.accessType,
      gender: user.gender,
      username: user.username,
      maritalStatus: user.maritalStatus,
      dateOfBirth: user.dateOfBirth,
      contact: {
        ...user.contact,
        secondaryPhoneNumber: user.contact.secondaryPhoneNumber || null,
        email: user?.contact?.email.length ? user.contact?.email : null,
      },
      contracts: user.contracts.map((i) => {
        delete i.id
        delete i.contractIndefinite
        i.roleId = i.role?.value
        delete i.role
        i.logisticsInfo = {
          ...i.logisticsInfo,
          accommodationId: i.logisticsInfo?.accommodationId || null,
          transportationType: i.logisticsInfo?.transportationType || null,
          transportationVehicleId: i.logisticsInfo?.transportationVehicleId || null,
          transportationTransferPointId: i.logisticsInfo?.transportationTransferPointId || null,
          foodMealSupplierId: i.logisticsInfo?.foodMealSupplierId || null,
          extraDutyAllowanceInCompanyAmount:
            i.logisticsInfo?.extraDutyAllowanceInCompanyAmount || 0,
          extraDutyAllowanceOutCompanyAmount:
            i.logisticsInfo?.extraDutyAllowanceOutCompanyAmount || 0,
          responsibilityAllowanceInCompanyAmount:
            i.logisticsInfo?.responsibilityAllowanceInCompanyAmount || 0,
          responsibilityAllowanceOutCompanyAmount:
            i.logisticsInfo?.responsibilityAllowanceOutCompanyAmount || 0,
          foodAllowanceInCompanyAmount: i.logisticsInfo?.foodAllowanceInCompanyAmount || 0,
          foodAllowanceOutCompanyAmount: i.logisticsInfo?.foodAllowanceOutCompanyAmount || 0,
          accomodationAllowanceInCompanyAmount:
            i.logisticsInfo?.accomodationAllowanceInCompanyAmount || 0,
          accomodationAllowanceOutCompanyAmount:
            i.logisticsInfo?.accomodationAllowanceOutCompanyAmount || 0,
          transportationAllowanceInCompanyAmount:
            i.logisticsInfo?.transportationAllowanceInCompanyAmount || 0,
          transportationAllowanceOutCompanyAmount:
            i.logisticsInfo?.transportationAllowanceOutCompanyAmount || 0,
        }
        i.accomodationTierPolicy = i.logisticsInfo?.accomodationTierPolicy?.value || null
        i.workScheduleModelId = i.workScheduleModelId?.value || null
        i.shiftChangeType = i.shiftChangeType?.value || null
        i.shouldPayOvertime = i.shouldPayOvertime || false
        return i
      }),
    }

    if (user.emergencyContact?.type?.value) {
      forSubmit.emergencyContact = {
        ...user.emergencyContact,
        type: user.emergencyContact?.type?.value || null,
      }
    }

    if (
      user.bankInfo.accountNumber ||
      user.bankInfo.branchCode ||
      user.bankInfo.ssnit ||
      user.bankInfo.bankName
    ) {
      // TODO mozda mmoze provera za jedan field samoi jer ako je prosao edit sa jednim vrv ostali isto postoje
      forSubmit.bankInfo = user.bankInfo
    }

    const resp = await baseUrl.post('/users', forSubmit, thunkAPI)

    if (state.documents?.length) {
      try {
        for (const document of state.documents) {
          const documentData: IDocumentDataRequest = {
            category: document.category,
            accessRestrictions: document.accessRestrictions,
            effectiveDate: document.effectiveDate.toISOString(),
            expiryDate: document.expiryDate.toISOString(),
            version: document.version,
            capabilityId: document.capability?.value,
          }
          const dataResp: AxiosResponse<IDocumentDataCreateResponse> = await baseUrl.post(
            `users/${resp.data.id}/document-data`,
            documentData,
            thunkAPI,
          )

          const formData = new FormData()
          formData.append('file', document.documentFile)
          await baseUrl.post(`users/${dataResp.data.id}/document-file`, formData)
        }
      } catch (error) {
        toast.error('Employee added but document upload failed.')
      }
    }

    if (state.notes?.length) {
      try {
        for (const note of state.notes) {
          const noteData: INoteRequest = {
            content: note.content,
            visibilityScope: note.visibilityScope,
            category: note.category,
          }
          await baseUrl.post(`users/${resp.data.id}/notes`, noteData, thunkAPI)
        }
      } catch (error) {
        console.log(error)
        toast.error('Employee added but note upload failed.')
      }
    }
    if (image && image?.length > 1) {
      const blobedImage = dataURItoBlob(image)

      try {
        const url = resp.data.putImagePresignedUrl
        await axios.put(url, blobedImage)

        return resp.data
      } catch (error) {
        return thunkAPI.rejectWithValue(error)
      }
    }

    await thunkAPI.dispatch(getUsersSimpleInfo(getParams({ location })))

    return resp.data
  } catch (error) {
    console.log(error)
    return thunkAPI.rejectWithValue(error)
  }
})

export const updateUser = createAsyncThunk(
  'users/updateUser',
  async (user: IEmployee, thunkAPI) => {
    try {
      const { image } = user
      delete user.image
      delete user.profileImage
      delete user.bankInfo?.id

      if (image && !image.startsWith('http')) {
        user.profileImage = true
      }

      const forSubmit: ISingleEmployeePatchRequest = {
        accessType: user.accessType,
        firstName: user.firstName,
        lastName: user.lastName,
        gender: user.gender,
        departmentId: user.department?.value,
        foodDietaryPreferenceType: user.foodDietaryPreferenceType?.value,
        gender: user.gender,
        username: user.username,
        maritalStatus: user.maritalStatus,
        dateOfBirth: user.dateOfBirth,
        contracts: user.contracts.map((contract: IContract) => {
          const c = { ...contract }
          if (typeof c.id === 'string') {
            delete c.id
          }
          c.shouldPayOvertime = c.shouldPayOvertime || false
          c.roleId = c.role?.value
          delete c.role
          delete c.name
          delete c.contractIndefinite
          console.log(c)
          c.logisticsInfo = {
            ...c.logisticsInfo,

            accommodationId: c.logisticsInfo?.accommodationId || null,
            transportationType: c.logisticsInfo?.transportationType ?? 1,
            transportationVehicleId: c.logisticsInfo?.transportationVehicleId || null,
            transportationTransferPointId: c.logisticsInfo?.transportationTransferPointId || null,
            foodMealSupplierId: c.logisticsInfo?.foodMealSupplierId || null,
            extraDutyAllowanceInCompanyAmount:
              c.logisticsInfo?.extraDutyAllowanceInCompanyAmount || 0,
            extraDutyAllowanceOutCompanyAmount:
              c.logisticsInfo?.extraDutyAllowanceOutCompanyAmount || 0,
            responsibilityAllowanceInCompanyAmount:
              c.logisticsInfo?.responsibilityAllowanceInCompanyAmount || 0,
            responsibilityAllowanceOutCompanyAmount:
              c.logisticsInfo?.responsibilityAllowanceOutCompanyAmount || 0,
            foodAllowanceInCompanyAmount: c.logisticsInfo?.foodAllowanceInCompanyAmount || 0,
            foodAllowanceOutCompanyAmount: c.logisticsInfo?.foodAllowanceOutCompanyAmount || 0,
            accomodationAllowanceInCompanyAmount:
              c.logisticsInfo?.accomodationAllowanceInCompanyAmount || 0,
            accomodationAllowanceOutCompanyAmount:
              c.logisticsInfo?.accomodationAllowanceOutCompanyAmount || 0,
            transportationAllowanceInCompanyAmount:
              c.logisticsInfo?.transportationAllowanceInCompanyAmount || 0,
            transportationAllowanceOutCompanyAmount:
              c.logisticsInfo?.transportationAllowanceOutCompanyAmount || 0,
            accomodationTierPolicy: c.logisticsInfo?.accomodationTierPolicy || null,
          }
          return c
        }),
        dateOfBirth: user.dateOfBirth,
        nationalId: user.nationalId,
        nationality: user.nationality,
        profileImage: user.profileImage,
        maritalStatus: user.maritalStatus,
        machines: user.machines,
        contact: user.contact,
        educationLevelType: user.educationLevelType?.value,
        logisticsInfo: user.logisticsInfo
          ? {
              ...user.logisticsInfo,
              mealTypeIds: user.logisticsInfo?.mealTypes?.map((t) => t.value) || [],
              foodDietaryPreferenceType: user.foodDietaryPreferenceType?.value,
              accommodationId: user.logisticsInfo.accommodation?.value,
              transportationType: user.logisticsInfo.transportationType ?? 1,
              transportationVehicleType: user.logisticsInfo?.transportationVehicleType?.value,
              // accommodationId: user.logisticsInfo.accommodation?.value,
              foodMealSupplierId: user.logisticsInfo.foodMealSupplier?.value,
              transportationTransferPointId: user.logisticsInfo.transportationTransferPoint?.value,
            }
          : null,
      }

      if (user.emergencyContact?.type?.value) {
        forSubmit.emergencyContact = {
          ...user.emergencyContact,
          type: user.emergencyContact?.type?.value || null,
        }
      }

      if (user.bankInfo) {
        forSubmit.bankInfo = user.bankInfo
      }
      const resp = await baseUrl.patch('/users/' + user.id, forSubmit, thunkAPI)
      const contracts = forSubmit.contracts
      console.log('c:', contracts)

      if (!contracts.length) {
        await baseUrl.patch('/users/' + user.id + '/contracts', { contracts: [] })
      }

      if (
        JSON.stringify(
          contracts.map((c) => {
            const copy = structuredClone(c)
            delete copy.contractIndefinite
            return copy
          }),
        ) !== JSON.stringify(user.contracts)
      ) {
        await baseUrl.patch('/users/' + user.id + '/contracts', {
          contracts: contracts.map((c) => {
            console.log(c)
            const copy = { ...c }

            copy.logisticsInfo = {
              ...c.logisticsInfo,

              accommodationId: c.logisticsInfo?.accommodationId || null,
              transportationType: c.logisticsInfo?.transportationType || 1,
              transportationVehicleId: c.logisticsInfo?.transportationVehicleId || null,
              transportationTransferPointId: c.logisticsInfo?.transportationTransferPointId || null,
              foodMealSupplierId: c.logisticsInfo?.foodMealSupplierId || null,
              extraDutyAllowanceInCompanyAmount:
                c.logisticsInfo?.extraDutyAllowanceInCompanyAmount || 0,
              extraDutyAllowanceOutCompanyAmount:
                c.logisticsInfo?.extraDutyAllowanceOutCompanyAmount || 0,
              responsibilityAllowanceInCompanyAmount:
                c.logisticsInfo?.responsibilityAllowanceInCompanyAmount || 0,
              responsibilityAllowanceOutCompanyAmount:
                c.logisticsInfo?.responsibilityAllowanceOutCompanyAmount || 0,
              foodAllowanceInCompanyAmount: c.logisticsInfo?.foodAllowanceInCompanyAmount || 0,
              foodAllowanceOutCompanyAmount: c.logisticsInfo?.foodAllowanceOutCompanyAmount || 0,
              accomodationAllowanceInCompanyAmount:
                c.logisticsInfo?.accomodationAllowanceInCompanyAmount || 0,
              accomodationAllowanceOutCompanyAmount:
                c.logisticsInfo?.accomodationAllowanceOutCompanyAmount || 0,
              transportationAllowanceInCompanyAmount:
                c.logisticsInfo?.transportationAllowanceInCompanyAmount || 0,
              transportationAllowanceOutCompanyAmount:
                c.logisticsInfo?.transportationAllowanceOutCompanyAmount || 0,
              accomodationTierPolicy:
                c.logisticsInfo?.accomodationTierPolicy?.value ||
                c.logisticsInfo?.accomodationTierPolicy ||
                null,
            }

            copy.shifts = copy.shifts.map((s) => ({
              order: s.order,
              shiftId: s.shiftId || s.shift?.id,
            }))
            if (typeof c.id == 'string') {
              delete copy.id
            }
            return {
              ...copy,
              workScheduleModelId: copy.workScheduleModelId?.value || copy.workScheduleModel?.id,
              shiftChangeType: copy.shiftChangeType?.value ?? copy.shiftChangeType,
              shouldPayOvertime: copy.shouldPayOvertime || false,
            }
          }),
        })
      }

      if (user.documents?.length) {
        try {
          for (const document of user.documents) {
            if (!document.alreadyCreated) {
              const documentData: IDocumentDataRequest = {
                category: document.category,
                accessRestrictions: document.accessRestrictions,
                effectiveDate: document.effectiveDate.toISOString(),
                expiryDate: document.expiryDate.toISOString(),
                version: document.version,
                capabilityId: document.capability?.value,
              }
              const dataResp: AxiosResponse<IDocumentDataCreateResponse> = await baseUrl.post(
                `users/${resp.data.id}/document-data`,
                documentData,
                thunkAPI,
              )

              const formData = new FormData()
              formData.append('file', document.documentFile)
              await baseUrl.post(`users/${dataResp.data.id}/document-file`, formData)
            }
          }
        } catch (error) {
          console.log(error)
          toast.error('Employee edited but document upload failed.')
        }
      }

      if (user.notes?.length) {
        try {
          for (const note of user.notes) {
            const noteData: INoteRequest = {
              content: note.content,
              visibilityScope: note.visibilityScope,
              category: note.category,
            }
            if (note.alreadyCreated) {
              await baseUrl.patch(`users/${resp.data.id}/notes/${note.id}`, noteData, thunkAPI)
            } else {
              await baseUrl.post(`users/${resp.data.id}/notes`, noteData, thunkAPI)
            }
          }
        } catch (error) {
          console.log(error)
          toast.error('Employee edited but note upload failed.')
        }
      }

      if (
        contracts.length &&
        !contracts.every((c: IContract) => user.contracts.some((ct) => ct.id === c.id))
      ) {
        const deletedContracts = contracts
          .filter((c: IContract) => !user.contracts.some((ct) => ct.id === c.id))
          .map((c: IContract) => c.id)
        for (const cId of deletedContracts) {
          cId && (await baseUrl.delete('/contracts/' + cId))
        }
      }
      if (image && image.length > 1 && !image.startsWith('http')) {
        const blobedImage = dataURItoBlob(image)
        try {
          const url = resp.data.putImagePresignedUrl
          await axios.put(url, blobedImage)
          return resp.data
        } catch (error) {
          console.log(error)
          return thunkAPI.rejectWithValue(error)
        }
      }

      return resp.data
    } catch (error) {
      console.log(error)
      return thunkAPI.rejectWithValue(error)
    }
  },
)

export const getUserStats = createAsyncThunk('users/getUserStats', async (_, thunkAPI) => {
  try {
    const resp: AxiosResponse<IEmployeesStatsResponse> = await baseUrl.get('/users-availability')
    return resp.data
  } catch (error) {
    console.log(error)
    return thunkAPI.rejectWithValue(error)
  }
})
const userSlice = createSlice({
  name: 'users',
  initialState,
  reducers: {
    clearEmployee: (state) => {
      state.singleUser = null
    },
    clearEmployeesList: (state) => {
      state.users = []
      state.totalCount = 0
      state.totalPages = 0
    },
  },
  extraReducers: {
    [getUsers.pending.type]: (state) => {
      state.isLoading = true
    },
    [getUsers.fulfilled.type]: (state, { payload }) => {
      state.isLoading = false

      state.users = payload.data
      state.totalCount = payload.totalCount
      state.totalPages = payload.totalPages
    },
    [getUsers.rejected.type]: (state, { payload }) => {
      state.isLoading = false
      handleErrors(payload)
    },
    [getUsersSimpleInfo.pending.type]: (state) => {
      state.isLoading = true
    },
    [getUsersSimpleInfo.fulfilled.type]: (state, { payload }) => {
      state.isLoading = false
      state.users = payload.data
      state.totalCount = payload.totalCount
      state.totalPages = payload.totalPages
    },
    [getUsersSimpleInfo.rejected.type]: (state, { payload }) => {
      state.isLoading = false
      handleErrors(payload)
    },
    [deleteUser.pending.type]: (state) => {
      state.isLoading = true
    },
    [deleteUser.fulfilled.type]: (state) => {
      try {
        state.isLoading = false
        toast.success('Employee successfully deleted.')
      } catch (error) {
        console.log(error)
      }
    },
    [deleteUser.rejected.type]: (state, { payload }) => {
      state.isLoading = false
      handleErrors(payload)
    },
    [getSingleUser.pending.type]: (state) => {
      state.isLoading = true
    },
    [getSingleUser.fulfilled.type]: (state, { payload }) => {
      state.isLoading = false
      const obj = payload
      obj.contracts = obj.contracts.map((item: IContract) => ({
        ...item,
        contractIndefinite: item.endDate ? false : true,
      }))
      obj.roleId = obj.role?.value
      obj.image = obj.getImagePresignedUrl
      delete obj.getImagePresignedUrl

      state.singleUser = obj
    },
    [getSingleUser.rejected.type]: (state) => {
      state.isLoading = false
    },
    [addUser.pending.type]: (state) => {
      state.isLoading = true
    },
    [addUser.fulfilled.type]: (state, { payload }) => {
      toast.success('Employee added')
    },
    [addUser.rejected.type]: (state, { payload }) => {
      state.isLoading = false
      handleErrors(payload)
    },
    [updateUser.pending.type]: (state) => {
      state.isLoading = true
    },
    [updateUser.fulfilled.type]: (state, { payload }) => {
      state.isLoading = false
      state.singleUser = payload
      toast.success('User updated')
    },
    [updateUser.rejected.type]: (state, { payload }) => {
      state.isLoading = false
      handleErrors(payload)
    },
    [getUserStats.pending.type]: (state) => {
      state.isLoading = true
    },
    [getUserStats.fulfilled.type]: (state, { payload }: { payload: IEmployeesStatsResponse }) => {
      state.isLoading = false
      state.infoShifts = payload?.shifts
        .filter((i) => {
          return i.numberOfUsers > 0
        })
        .map((i) => {
          return {
            shift: i.name,
            number: i.numberOfUsers,
            percent: ((i.numberOfUsers * 100) / payload.totalWorkers).toFixed(1),
          }
        })
      delete payload.shifts
      state.stats = payload
    },
    [getUserStats.rejected.type]: (state) => {
      state.isLoading = false
    },
    [importUsers.pending.type]: (state) => {
      state.isLoading = true
    },
    [importUsers.fulfilled.type]: (state) => {
      state.isLoading = false
      toast.success('Employees imported successfully')
    },
    [importUsers.rejected.type]: (state, { payload }) => {
      state.isLoading = false
      handleErrors(payload)
    },
    [terminateContract.pending.type]: (state) => {
      state.isLoading = true
    },
    [terminateContract.fulfilled.type]: (state, { payload }) => {
      state.isLoading = false
      toast.success(`Contract termination request has been sent.`)
      if (payload) {
        // state.singleUser.state = 3
      }
    },
    [terminateContract.rejected.type]: (state, { payload }) => {
      state.isLoading = false
      handleErrors(payload)
    },
  },
})

export const { clearEmployee, clearEmployeesList } = userSlice.actions

export default userSlice.reducer
